if (typeof customElements.get('collection-description') === 'undefined') {

  class CollectionDescription extends HTMLElement {

    connectedCallback() {
      this.textEl = this.querySelector('[data-cd-text]');
      this.toggleEl = this.querySelector('[data-cd-toggle]');
      this.moreEl = this.querySelector('[data-cd-more]');
      this.lessEl = this.querySelector('[data-cd-less]');

      if (!this.hasAttribute('data-truncate') || !this.textEl || !this.toggleEl) return;

      this.toggleEl.addEventListener('click', this.onToggle.bind(this));

      let timer;
      window.addEventListener('resize', () => {
        clearTimeout(timer);
        timer = setTimeout(this.evaluate.bind(this), 150);
      });

      this.evaluate();
    }

    /* Nasconde il bottone quando il testo entra gia tutto */
    evaluate() {
      if (this.classList.contains('is-open')) return;
      this.classList.remove('is-short');
      const overflows = this.textEl.scrollHeight > this.textEl.clientHeight + 4;
      this.classList.toggle('is-short', !overflows);
    }

    onToggle() {
      const open = !this.classList.contains('is-open');
      this.classList.toggle('is-open', open);
      this.toggleEl.setAttribute('aria-expanded', open ? 'true' : 'false');
      this.moreEl.hidden = open;
      this.lessEl.hidden = !open;
    }

  }

  customElements.define('collection-description', CollectionDescription);

}
